import loadable from '@loadable/component';
import Loading from '../../components/Loader';
import { fetchCategoryFromKey } from '../../actions/category';
import { fetchModalQuestions } from '../../actions/questions';

const GQSimple = loadable(() => import('./index'), {
  fallback: Loading
});

GQSimple.needs = async (props, { dispatch }) => {
  const category = props.params.category;
  const displayCategory = dispatch(fetchCategoryFromKey(category));
  const modalQuestions = dispatch(fetchModalQuestions(category));
  return await Promise.all([displayCategory, modalQuestions]);
};

export default GQSimple;
